/*
 * Vignette annotée : image scannée + overlay bounding boxes des allégations à risque.
 * - Boxes rouges pour severity=red, orange sinon.
 * - Tooltip au hover avec l'expression détectée.
 * - Responsive : conserve les proportions natives.
 */
export default function AnnotatedImage({ imageB64, mime, regions, alt = "Packaging scanné" }) {
  if (!imageB64) return null;
  const src = `data:${mime || "image/jpeg"};base64,${imageB64}`;
  const hasRegions = Array.isArray(regions) && regions.length > 0;

  return (
    <div className="hairline p-3 sm:p-4 rounded-lg bg-white" data-testid="annotated-image-card">
      <div className="flex items-center justify-between mb-3">
        <p className="eyebrow">Vignette annotée</p>
        <p className="text-[10px] font-mono text-muted-foreground">
          {hasRegions ? `${regions.length} zone${regions.length > 1 ? "s" : ""} à risque` : "aucune zone détectée"}
        </p>
      </div>
      <div className="relative w-full overflow-hidden rounded-md bg-slate-50" data-testid="annotated-image-wrapper">
        <img src={src} alt={alt} className="w-full h-auto block" data-testid="annotated-image-src" />
        {hasRegions && regions.map((r, i) => {
          const isRed = r.severity === "red";
          const color = isRed ? "rgba(239,68,68,0.85)" : "rgba(245,158,11,0.85)";
          const bg = isRed ? "rgba(239,68,68,0.18)" : "rgba(245,158,11,0.18)";
          const style = {
            position: "absolute",
            left: `${(r.x || 0) * 100}%`,
            top: `${(r.y || 0) * 100}%`,
            width: `${(r.w || 0.1) * 100}%`,
            height: `${(r.h || 0.05) * 100}%`,
            border: `2px solid ${color}`,
            background: bg,
            borderRadius: "3px",
            pointerEvents: "auto",
          };
          return (
            <div key={i} style={style} title={r.term || r.text || ""} data-testid={`annotated-region-${i}`} className="group">
              <span className="absolute -top-6 left-0 text-[10px] font-mono uppercase text-white px-1.5 py-0.5 rounded" style={{ background: color }}>
                {isRed ? "RED" : "ORANGE"}
              </span>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-muted-foreground mt-2 italic">
        Les zones surlignées correspondent aux allégations qualifiées à risque par le pipeline lexique + LLM. Coordonnées estimées, marge d'erreur ±5 %.
      </p>
    </div>
  );
}
